import "@/App.css";
import { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Donuts } from "@/components/Donuts";
// Temporarily unsurfaced (code kept — restore here + in <main> to re-enable):
// import { BakersDozen } from "@/components/BakersDozen";
import { Truck } from "@/components/Truck";
import { Mission } from "@/components/Mission";
// Temporarily unsurfaced (code kept — restore in <main> + NAV_LINKS to re-enable):
// import { Merch } from "@/components/Merch";
// import { Rewards } from "@/components/Rewards";
import { Quote } from "@/components/Quote";
import { Locations } from "@/components/Locations";
import { Contact } from "@/components/Contact";
import { OurStory } from "@/components/OurStory";
import { NotFound } from "@/components/NotFound";
import { Footer } from "@/components/Footer";
import { CookieConsent } from "@/components/CookieConsent";

const Home = () => (
  <>
    <Hero />
    <div
      data-testid="hero-donuts-divider"
      className="h-8 border-y-2 border-[#111111]"
      style={{
        backgroundImage: "url('/frosting-band.svg')",
        backgroundRepeat: "repeat-x",
        backgroundSize: "auto 100%",
      }}
    />
    <Donuts />
    {/* Baker's Dozen temporarily unsurfaced — code preserved:
    <BakersDozen />
    */}
    {/* "Find the Truck" schedule sits directly under the donuts */}
    <Locations />
    {/* Truck + Mission condensed into one "Our Story" section for now.
        Both components remain independent and can be split out again. */}
    <div id="story">
      <Truck />
      <Mission showVideo={false} showLearnMore={false} showSocial={false} />
    </div>
    {/* Temporarily unsurfaced — code preserved:
    <Merch />
    <Rewards />
    */}
    <Contact />
    {/* Catering RFQ moved to the bottom of the page */}
    <Quote />
  </>
);

const SITE_URL = "https://www.bobosdonuts.com";

const PAGE_META = {
  "/": {
    title: "Bobo's Donuts™ — Sweetness with a Mission",
    description:
      "Bobo's Donuts serves hand-cut, from-scratch donuts fresh off our food truck in Mattawan, Michigan. Find our weekly schedule, flavors, and catering.",
  },
  "/about": {
    title: "Bobo's Donuts™ — Our Story",
    description:
      "Meet the family behind Bobo's Donuts — a Mattawan, Michigan donut truck on a mission to build a more inclusive, sweeter community together.",
  },
};

const NOT_FOUND_META = {
  title: "Bobo's Donuts™ — Page Not Found",
  description:
    "This page took a donut break. Head back to Bobo's Donuts for fresh flavors, our truck schedule, and catering across Mattawan, Michigan.",
};

const setMetaDescription = (content) => {
  let tag = document.querySelector('meta[name="description"]');
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", "description");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
};

const RouteEffects = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const meta = PAGE_META[pathname] || NOT_FOUND_META;
    document.title = meta.title;
    setMetaDescription(meta.description);
    const isKnown = Boolean(PAGE_META[pathname]);
    setCanonical(`${SITE_URL}${isKnown ? pathname : "/"}`);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-[#f7f0eb] min-h-screen overflow-x-hidden">
      <Toaster position="top-center" richColors />
      <RouteEffects />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<OurStory />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;
